import React from 'react'
import Classes from './SectionCards.module.css'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const ChurnIcon = (props) => (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z" /></svg>
    </>
)
const DeleteIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg>
)
const FileIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" /></svg>
)

export default function SectionCards() {

    const navigate = useNavigate();

    const navigateToSignup = () => {
        navigate('/signup');
    }

    return (
        <div id='features-section' className={Classes.hero} >
            <div className={Classes.miniText} > Key Features </div>
            <h1 className={Classes.subheading}> AI-Powered Privacy Protection </h1>
            <p className={Classes.text}>
                PrivacyBot uses advanced AI and automation to track, identify, and remove your personal <br /> data from data brokers, giving you complete control over your digital footprint.
            </p>

            <div className={Classes.cardsCon} >
                <div className={Classes.card} >
                    <div className={Classes.imageCon} >
                        <ChurnIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Customizable <br /> AI Privacy Bot</h3>
                    <h5>Leverage powerful analytics to optimize performance, streamline operations, and scale with new and existing clients.</h5>
                </div>
                <div className={`${Classes.card} ${Classes.greenCard}`} >
                    <div className={Classes.imageCon} >
                        <DeleteIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Automated <br /> Data Deletion</h3>
                    <h5>Save time with automated data removal and notifications, ensuring your personal data is gone from brokers.</h5>
                </div>
                <div className={Classes.card} >
                    <div className={Classes.imageCon} >
                        <FileIcon height='30px' width='30px' fill='white' />
                    </div>
                    <h3>Comprehensive <br /> Monthly Reports</h3>
                    <h5>Get detailed insights on data exposure, removals, and new privacy risks in an easy-to-read report.</h5>
                </div>
            </div>

            <motion.div
                whileTap={{ scale: 0.97 }}
                whileHover={{ scale: 1.03 }}
            >
                <button className={Classes.startBtn} onClick={navigateToSignup} > <h5>Get started for free</h5> </button>
            </motion.div>
        </div>
    )
}
